import api from "../../client";

export const deleteFieldRequest = async (
  id: string | undefined,
): Promise<{}> => {
  const { data } = await api.delete(`/field/${id}`);

  return data;
};
